import React, {useEffect,useState} from 'react';
import alanBtn from "@alan-ai/alan-sdk-web"
import wordsToNumber from "words-to-numbers"

import NewsCards from "./components/NewsCards/NewsCards"
import useStyles from "./styles.js"

const alanKey = 'f27089ef8bcf44d54e04f068465c9ee82e956eca572e1d8b807a3e2338fdd0dc/stage'
function App() {

  const classes = useStyles()
  const [newsArticles, setNewsArticles] =  useState([])
  const [activeArticle, setActiveArticle] = useState(-1)

  useEffect(()=>{
      alanBtn({
        key: alanKey,
        onCommand: ({command, articles, number})=>{
          if(command === 'newHeadlines'){
            setNewsArticles(articles) 
            setActiveArticle(-1)
          }else if(command === 'highlight'){
            setActiveArticle((prevActiveArticle)=>prevActiveArticle + 1)
          }else if(command === 'open'){
            const parsedNumber = number.length>2 ? wordsToNumber(number, {fuzzy: true}) : number
            const article = articles[parsedNumber - 1]
            if(parsedNumber>20){
              alanBtn().playText('Please Try Again')
            }else if(article){
               window.open(article.url, '_blank')
               alanBtn().playText('Opening...')
            }
           
          }
        }
      })    
  },[])
  return (
    <div>
      <div className={classes.logoContainer}>
        <img src="https://alan.app/voice/images/previews/preview.jpg" className={classes.alanLogo} alt="logo" />
      </div>
      <NewsCards articles ={newsArticles} activeArticle={activeArticle} />
    </div>
  );
}

export default App;
